import { useState } from 'react';

export const useInputValue = initialValue => {
    const [input, setInput] = useState({ value: initialValue, error: false });
    const onChange = (event, error) => setInput({ value: event.target.value, error });
    return { ...input, onChange };
};
